/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
const initialState = {
  predios: [],
  Folio: null,
  Importe: null,
  Descripcion: null,
  receipts: [],
};

const mutations = {
  SET_DATA(state, payload) {
    Object.assign(state, payload);
  },
  CLEAR_DATA(state) {
    state.Folio = null;
    state.Importe = null;
    state.Descripcion = null;
    state.predios = [];
  },
  CLEAR_INFO(state) {
    state.Folio = null;
    state.Importe = null;
    state.Descripcion = null;
  },
  CLEAR_RECEIPTS(state) {
    state.receipts = [];
  },
  SET_RECEIPTS(state, payload) {
    state.receipts = payload;
  },
};

const actions = {
  SET_DATA({ commit }, payload) {
    if (typeof payload === 'object') {
      commit('SET_DATA', payload);
    }
  },
  SET_RECEIPTS({ commit }, payload) {
    if (typeof payload === 'object') {
      commit('SET_RECEIPTS', payload);
    }
  },
  CLEAR_DATA({ commit }) {
    commit('CLEAR_DATA');
  },
  CLEAR_RECEIPTS({ commit }) {
    commit('CLEAR_RECEIPTS');
  },
  CLEAR_INFO({ commit }) {
    commit('CLEAR_INFO');
  },
};

export default {
  state: initialState,
  mutations,
  actions,
  namespaced: true,
};
